import './_leasing-offer.twig';
import './_leasing-offer.scss';
import $ from 'jquery';
import protons from '../../00-protons';
import { LeasingOfferDataEvent } from '../../00-protons/events/leasing-offer-data-event';

export const name = 'leasing-offer';

export function disable() {}

const ptdModClass = 'leasing-offer--ptd';
const hasDetailsClass = 'leasing-offer__content--has-details';

const leasingOfferSelector = '.leasing-offer';
const leasingOfferFeatureFieldSelector = '.leasing-offer__feature-field';
const ptdFormSelector = '.leasing-offer__ptd-form';
const customTextSelector = '.leasing-offer__custom-text';
const contentSelector = '.leasing-offer__content';
const rightContentSelector = '.leasing-offer__right-content';
const leftContentSelector = '.leasing-offer__left-content';
const l1CollapseSelector = '.leasing-offer__grid-element--l-2 .collapse';
const l2CollapseSelector = '.leasing-offer__grid-element--l-3 .collapse';

const ptdFormInputName = 'ptd';

let l1Open = false;
let l2Open = false;

const adjustCustomTextHeight = (leasingOffer, reset = false) => {
  const customText = leasingOffer.querySelector(customTextSelector);
  const content = customText.closest(contentSelector);
  const hasDetails = content.classList.contains(hasDetailsClass);

  if (reset || l1Open || (l2Open && hasDetails)) {
    customText.style.removeProperty('max-height');
    return;
  }

  const rightContent = content.querySelector(rightContentSelector);
  const variableHeightContainer = content.querySelector(leftContentSelector);
  // sum of margins and the collapsed text boxes
  const heightToAdd = hasDetails ? 56 * 2 + 20 * 3 : 56 + 20 * 2;
  const leftHeight = variableHeightContainer.clientHeight + heightToAdd;
  const rightHeight = rightContent.clientHeight;
  const customTextHeight = customText.clientHeight;

  if (rightHeight < leftHeight) {
    customText.style.removeProperty('max-height');
    return;
  }

  const maxHeight = customTextHeight - (rightHeight - leftHeight);
  if (maxHeight > 0) {
    customText.style['max-height'] = `${
      customTextHeight - (rightHeight - leftHeight)
    }px`;
  }
};

/**
 * @param {HTMLDocument|HTMLElement} context
 */
export function enable(context) {
  Array.from(context.querySelectorAll(leasingOfferSelector)).forEach(
    (leasingOffer) => {
      const mobileBreakpointOnChange = () => {
        if (protons.minMobileBreakpoint.matches) {
          adjustCustomTextHeight(leasingOffer);
        } else {
          adjustCustomTextHeight(leasingOffer, true);
        }
      };
      mobileBreakpointOnChange();
      leasingOffer.addEventListener(
        protons.event.layoutShift,
        mobileBreakpointOnChange
      );
      protons.minMobileBreakpoint.addEventListener(
        'change',
        mobileBreakpointOnChange
      );
      const l1Collapse = leasingOffer.querySelector(l1CollapseSelector);
      const $l1Collapse = $(l1Collapse);
      $l1Collapse.on('shown.bs.collapse', () => {
        l1Open = true;
        adjustCustomTextHeight(leasingOffer, true);
      });
      $l1Collapse.on('hidden.bs.collapse', () => {
        l1Open = false;
        adjustCustomTextHeight(leasingOffer);
      });
      if (
        leasingOffer
          .querySelector(contentSelector)
          .classList.contains(hasDetailsClass)
      ) {
        const l2Collapse = leasingOffer.querySelector(l2CollapseSelector);
        const $l2Collapse = $(l2Collapse);
        $l2Collapse.on('shown.bs.collapse', () => {
          l2Open = true;
          adjustCustomTextHeight(leasingOffer, true);
        });
        $l2Collapse.on('hidden.bs.collapse', () => {
          l2Open = false;
          adjustCustomTextHeight(leasingOffer);
        });
      }

      /** @type HTMLFormElement | null */
      const ptdForm = leasingOffer.querySelector(ptdFormSelector);
      if (ptdForm) {
        const updatePtd = () => {
          if (ptdForm.elements[ptdFormInputName].value) {
            leasingOffer.classList.add(ptdModClass);
          } else {
            leasingOffer.classList.remove(ptdModClass);
          }
        };
        updatePtd();
        ptdForm.addEventListener('change', updatePtd);
      }

      const leasingOfferIndex = parseInt(leasingOffer.dataset.index);
      const leasingOfferTitle = leasingOffer.dataset.title;
      leasingOffer.dispatchEvent(
        new LeasingOfferDataEvent(leasingOfferIndex, leasingOfferTitle, {
          features: {},
        })
      );

      const featureFields = Array.from(
        leasingOffer.querySelectorAll(leasingOfferFeatureFieldSelector)
      );

      const featureFieldOnChange = () => {
        leasingOffer.dispatchEvent(
          new LeasingOfferDataEvent(
            leasingOfferIndex,
            leasingOfferTitle,
            featureFields.reduce(
              (features, featureField) => {
                const {
                  featureLabel,
                  sourceInputSelector,
                } = featureField.dataset;
                const sourceInput = featureField.querySelector(
                  sourceInputSelector
                );
                if (sourceInput.value) {
                  features[featureLabel] = sourceInput.value;
                }
                return features;
              },
              {}
            )
          )
        );
      };
      featureFieldOnChange();

      featureFields.forEach((featureField) => {
        const { sourceInputSelector } = featureField.dataset;
        const sourceInput = featureField.querySelector(sourceInputSelector);
        sourceInput.addEventListener('change', () => {
          featureFieldOnChange();
        });
      });
    }
  );
}

export default enable;
